module.exports = __webpack_public_path__ + "assets/img/140b991a8c70bafc96b739cebb2dcb27.svg";